import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ChangeShipmentTypeRequest } from 'app/generated/backend/shipment/api/change-shipment-type-request';
import { ChangeShipmentTypeResponse } from 'app/generated/backend/shipment/api/change-shipment-type-response';

@Injectable()
export class ChangeShipmentTypeHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	post(
		request: ChangeShipmentTypeRequest
	): Observable<JsonResourceResponse<ChangeShipmentTypeResponse>> {
		return this.http.post<JsonResourceResponse<ChangeShipmentTypeResponse>>('api/v1/shipment/changeShipmentType', request).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		ChangeShipmentTypeHandlerService
	]
})
export class ChangeShipmentTypeHandlerModule { }
